import { FONT_SIZE, EllipsisAccordion, Icon } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";
import type { ItemEpisodeProps } from "./type";
import { isTouchDisplay } from "~/const/device";
import { useMatchMedia } from "~/hooks/use-match-media";
import { generateEpisodeNumberTitle } from "~/util/generate-episode-number-title";

/**
 * Base Application 専用の ItemEpisodeコンポーネント
 * - 「作品末端のタブ情報ブロック」でのみ使用される想定のコンポーネント
 * @param props {@link ItemEpisodeProps}
 */
export const ItemEpisode = (props: ItemEpisodeProps) => {
  const {
    episodeNumberName,
    episodeTitle,
    episodeImageWidth,
    episodeImageHeight,
    tagComponent = null,
    episodeDescription,
    purchasedText,
    supplementText,
    isDownloadIcon = false,
    isDownloadIconActive = true,
    onPurchasedBtnClick,
    onThumbnailClick,
    onIconClick,
    ...itemThumbnailProps
  } = props;

  const { isSpSize, isPcSize } = useMatchMedia();

  const suitableEpisodeText = generateEpisodeNumberTitle({ episodeTitle, episodeNumberName });

  return (
    <Styled.DivRootPadding role="group">
      <Styled.DivItemFlexContainer>
        <Styled.BtnThumbnail
          type="button"
          name="Thumbnail Image Button"
          aria-label="Thumbnail Image Button"
          disabled={!itemThumbnailProps.visiblePlayIcon}
          aria-disabled={!itemThumbnailProps.visiblePlayIcon}
          onClick={() => onThumbnailClick && onThumbnailClick()}
        >
          <Styled.ItemThumbnail
            {...itemThumbnailProps}
            borderRadius="8px"
            width={`${episodeImageWidth}px`}
            height={`${episodeImageHeight}px`}
          />
        </Styled.BtnThumbnail>

        <Styled.DivEpisodeGrid>
          <Styled.TitleGrid height={episodeImageHeight}>
            {tagComponent !== null && tagComponent}

            <Styled.SecHeadingWrapper>
              <Styled.HeadingEpisodeTitle>{suitableEpisodeText}</Styled.HeadingEpisodeTitle>
            </Styled.SecHeadingWrapper>
          </Styled.TitleGrid>

          {!isSpSize && episodeDescription && (
            <EllipsisAccordion
              line={3}
              text={episodeDescription}
              label="description"
              fontSize={FONT_SIZE.S}
              lineHeight={1.6}
            />
          )}

          {!isSpSize && purchasedText !== undefined && (
            <Styled.BtnPurchase type="button" onClick={() => onPurchasedBtnClick && onPurchasedBtnClick()}>
              {purchasedText}
            </Styled.BtnPurchase>
          )}

          {!isSpSize && supplementText && <Styled.ParSupplementText>{supplementText}</Styled.ParSupplementText>}
        </Styled.DivEpisodeGrid>

        {isPcSize && !isTouchDisplay && isDownloadIcon && (
          <Styled.DivDownloadIconFlexContainer>
            <Styled.BtnDownloadIcon
              type="button"
              name="DownloadModalを開くボタン"
              aria-label="DownloadModalを開くボタン"
              disabled={!isDownloadIconActive}
              onClick={() => onIconClick && onIconClick()}
            >
              <Icon name="download" size="XXL" color="GRAY900" />
            </Styled.BtnDownloadIcon>
          </Styled.DivDownloadIconFlexContainer>
        )}
      </Styled.DivItemFlexContainer>

      {isSpSize && episodeDescription && (
        <Styled.EllipsisAccordion
          line={2}
          text={episodeDescription}
          label="description"
          fontSize={FONT_SIZE.S}
          lineHeight={1.6}
          isAccordionBtn={false}
        />
      )}

      {isSpSize && supplementText && <Styled.ParSupplementText>{supplementText}</Styled.ParSupplementText>}

      {isSpSize && purchasedText !== undefined && (
        <Styled.BtnPurchase type="button" onClick={() => onPurchasedBtnClick && onPurchasedBtnClick()}>
          {purchasedText}
        </Styled.BtnPurchase>
      )}
    </Styled.DivRootPadding>
  );
};
